<a
  *ngIf="target$ | async as link"
  [finLink]="link.url"
  [external]="link.external"
  class="block nordic-blue-900-text no-underline align-right font-body-1 bold-type pr-xxsmall-r underline-hover"
>
  {{ teaserTitle$ | async }}
  <fcom-icon name="arrow-right" class="ir-xsmall"></fcom-icon>
</a>
